
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import { Field } from "@/utils/documents/field";
import Vue from "vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import AppPropSelectAutocomplete from "@/components/prop-select/PropSelectAutocomplete.vue";
import { getReminderMapPropSelectGroup } from "@/utils/prop-select/reminder-map-prop-group";
import { getReminderLayoutPropSelectGroup } from "@/utils/prop-select/reminder-layout-prop-select-group";
import { Condition } from "@/utils/condition/condition";
import AppFieldConditionEdit from "../models/ConditionEdit.vue";

export default Vue.extend({
	data() {
		return {
			lang: "",
			hiddenKeys: [] as string[],
		};
	},
	props: {
		value: {
			type: Object as () => Field,
			required: true
		},
		selectedLang: String,
		title: {
			type: String,
			default():string{
				return this.$ct("edit-prop").toString();
			}
		}
	},
	computed: {
		props(): PropSelectGroup {
			return getReminderMapPropSelectGroup();
		},
		conditionProps():PropSelectGroup{
			return getReminderLayoutPropSelectGroup();
		}
	},
	watch: {
		selectedLang: {
			immediate: true,
			handler(lang: string) {
				this.lang = lang;
			}
		},
		lang(lang: string) {
			if (lang == this.selectedLang) return;
			this.$emit("update:selectedLang", lang);
		},
	},
	methods: {
		close() {
			this.$emit("close");
		},
		shouldShowKey(key:string):boolean{
			return this.hiddenKeys.indexOf(key) == -1;
		},
		removeCondition(i:number){
			this.value.Conditions.splice(i,1);
		},
		async addCondition(){
			let condition = new Condition();
			this.hiddenKeys.push(condition.key);
			this.value.Conditions.push(condition);
			await this.$nextTick();
			this.hiddenKeys.pop();
		},
	},
	components: {
		AppCustomLangSelect,
		AppPropSelectAutocomplete,
		AppFieldConditionEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
